module.exports = __webpack_public_path__ + "img/consult_info2.6941c4dd.png";